import { customEventFactory } from '@dreryk/react-common';

const SHOW_PRESCRIPTION_VISIT_DATA_MODAL_EVENT = 'ShowPrescriptionVisitDataModalEvent';

type ShowPrescriptionVisitDataModalEventData = {
   validateOnOpen: boolean;
};

const [
   dispatchShowPrescriptionVisitDataModalEvent,
   registerShowPrescriptionVisitDataModalEventListener,
] = customEventFactory<ShowPrescriptionVisitDataModalEventData>(SHOW_PRESCRIPTION_VISIT_DATA_MODAL_EVENT);

export type { ShowPrescriptionVisitDataModalEventData };
export { dispatchShowPrescriptionVisitDataModalEvent, registerShowPrescriptionVisitDataModalEventListener };
